@if (spinner) {
  <app-spinner></app-spinner>
}
<div class="inner-page-header">
  <h3>العقود التجارية</h3>
</div>
@if (projects) {
<div class="request-control" #goUp>
  <div class="right-side">
    @if (filterData) {
    <app-filter [filterData]="filterData" [filterDataInit]="filterDataInit" [filterPage]="filterPage"
      (formValus)="filterFormValues($event)">
    </app-filter>
    }
    <quick-search (searchResults)="quickSearch($event)"></quick-search>
  </div>
  <div class="new-element">
    <button class="btn btn-add" (click)="addProject()">
      <img src="assets/images/svg/add-icon.svg" alt="" />
      إضافة عقد تجاري
    </button>
  </div>
</div>
@if (projects && projects.length > 0) {
<ayen-selected-count
  [itemsPerPage]="currentItemsPerPage"
  [selectedRows]="selectedRowsPK"
  [totalRowsSelected]="totalRowsSelected"
  [pageTitle]="pageTitle"
  [totalItems]="config.totalItems"
  (setTotalRowsSelected)="selectTotalRows($event)"
>
</ayen-selected-count>
}
<div class="request-table">
  <div class="table-responsive">
    <table id="project-table" aria-label="" class="table table-striped">
      <thead>
        <tr>
          <th id="">
            <label class="checkbox-container">
              <input
                type="checkbox"
                #selectAllElm
                id="custom_check_all"
                (click)="selectAll($event.target)"
              />
              <span class="checkmark"></span>
            </label>
            <span
              class="checkbox-label"
              (click)="toggleSorting('shortcode', img1)"
            >
              كود العقد
              <img #img1 [src]="imgDefault" alt="" />
            </span>
          </th>
          <th (click)="toggleSorting('name', img2)">
            اسم العقد
            <img #img2 [src]="imgDefault" alt="" />
          </th>
          <th>حالة العقد</th>
          <th>تابع لشركة</th>
          <th (click)="toggleSorting('active_date', img3)">
            تاريخ إعتماد العقد
            <img #img3 [src]="imgDefault" alt="" />
          </th>
          <th (click)="toggleSorting('expiry_date', img4)">
            تاريخ تسليم العملاء
            <img #img4 [src]="imgDefault" alt="" />
          </th>
        </tr>
      </thead>
      <tbody>
        @for (project of projects | paginate: config; track project; let i =
        $index) {
        <tr
          (click)="openProject(project.pk)"
          class="table-row"
          data-href="requests-waitingForCompleted.html"
          role="row"
        >
          <td>
            <label class="checkbox-container" (click)="stopPropagation($event)">
              <input
                type="checkbox"
                #checkBoxList
                (click)="selectsSingleRow($event, project.pk, i)"
                [id]="i + '_' + project.pk"
              />
              <span class="checkmark"></span>
            </label>
            <span class="checkbox-label">
              <a href="/pages/projects/{{ project.pk }}">{{
                project.shortcode
              }}</a>
            </span>
          </td>
          <td>{{ project.name ? project.name : "-" }}</td>
          <td>{{ project.status ? project.project_status.name : "-" }}</td>
          <td>{{ project.company ? project.company.name_arabic : "-" }}</td>
          <td>{{ project.active_date ? project.active_date : "-" }}</td>
          <td>{{ project.expiry_date ? project.expiry_date : "-" }}</td>
        </tr>
        } @if (projects.length === 0) {
        <tr>
          <td colspan="5" class="text-center">لا توجد بيانات</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
@if (projects && projects.length > 0) {
<ayen-pagination
  (pageData)="pageChanged($event)"
  (pageSize)="pageSizeChanged($event)"
  [totalCount]="config.totalItems"
  [pageTitle]="pageTitle"
  [itemsPerPage]="config.itemsPerPage"
  (pageChange)="changeToSpecific($event)"
  [currentPage]="config.currentPage"
>
</ayen-pagination>
} }
